<template>
  <OverlayCard width="m" @cancel="$emit('cancel')">
    <template #title>
      {{ $t('licensing.upgradeCard.beta.text.title') }}
    </template>

    <template #content>
      <div>
        <i18n-t tag="p" keypath="licensing.upgradeCard.beta.text.main">
          <template #contactUs>
            <a :href="`mailto:${$config.supportMail}`">{{ $t('licensing.upgradeCard.beta.text.contactUs') }}</a>
          </template>
        </i18n-t>
        <p>
          <button @click="$emit('cancel')" class="license-upgrade-card__inline-button">
            {{ $t('licensing.action.limited') }}
          </button>
        </p>
      </div>
    </template>

    <template #footer>
      <LicenseTrialAction v-if="canHaveTrial" />

      <LicenseUpgradeAction :color="canHaveTrial ? 'blue' : 'grey'" />
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LicenseTrialAction from '@components/license/LicenseTrialAction.vue';
import LicenseUpgradeAction from '@components/license/LicenseUpgradeAction.vue';

export default defineComponent({
  emits: { cancel: null },
  name: 'LicenseUpgradeCard',

  components: {
    LicenseTrialAction,
    LicenseUpgradeAction,
  },

  props: {
    canHaveTrial: {
      type: Boolean,
      required: true,
    },
  },
});
</script>

<style lang="scss">
@use 'mixins/button';

.license-upgrade-card__inline-button {
  @include button.button-inline;
}
</style>
